import { render, staticRenderFns } from "./TwImage.vue?vue&type=template&id=50a57272"
import script from "./TwImage.vue?vue&type=script&lang=js"
export * from "./TwImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports